import {
  IconArrowNarrowDown,
  IconArrowNarrowUp,
  IconArrowsVertical,
  TablerIconsProps,
} from '@tabler/icons-react';

import { ETariffProfileRuleType } from '../../../core/tariff-profile';
import { ERuleValueType, TariffProfileRulesRecord } from './types';

export const detectRuleValue = (record: TariffProfileRulesRecord) => {
  const result: { value: number | null; valueType: ERuleValueType | null } = {
    valueType: null,
    value: null,
  };

  if (typeof record.rule?.amount === 'number') {
    result.valueType = ERuleValueType.amount;
    result.value = record.rule.amount;
  }

  if (typeof record.rule?.percent === 'number') {
    result.valueType = ERuleValueType.percent;
    result.value = record.rule.percent;
  }

  return result;
};

export const ruleTypeMapIcons: Record<
  ETariffProfileRuleType,
  (props: TablerIconsProps) => JSX.Element
> = {
  [ETariffProfileRuleType.increase]: () => (
    <IconArrowNarrowUp size={18} color="tomato" />
  ),
  [ETariffProfileRuleType.fixed]: () => (
    <IconArrowsVertical size={18} color="gray" />
  ),
  [ETariffProfileRuleType.decrease]: () => (
    <IconArrowNarrowDown size={18} color="green" />
  ),
};
